export default {
  en: {
    preview_title1: 'Single suited or double suited?',
    article_examples: 'Examples: ',
    article1_title: `
            Single suited or double suited? 
            `,
    article1_header: 'Single suited or double suited?',
    article1_introduction: `
            There are two types of starting hands in Pot Limit Omaha.
            `,
    //
    article1_unpaired_title: `
            - Unpaired (starting hand with no pair)
        `,
    article1_unpaired_text: `
            Note that they are all ranked from the highest card to the lowest. In the future, 
            this will be useful to us. By analogy with hold'em for a simplified understanding, 
            we can say that we have
            <img src="AtCARD" class="textCard" alt="card" /> - high
            <img src="QtCARD" class="textCard" alt="card" /> - high 
            <img src="9tCARD" class="textCard" alt="card" /> - high
            <img src="JtCARD" class="textCard" alt="card" /> - high                 
            <img src="KtCARD" class="textCard" alt="card" /> - high preflop.  
            But they are distributed according to the principle "Two High Cards" + "Two Side Cards"
        `,
    article1_paired_title: `
            - Paired (starting hand with at least one pair)
        `,
    //
    article1_paired_text: `
        In this case, the highest combination in the hand - a pair - comes out on top. And to it, 
        by analogy with the examples from Unpaired, two Side Cards are added. Likewise from highest 
        to lowest
        `,
    article1_paired_conclusion: `
        If there are two pair in the starting hand, then the top pair is taken as the base first. As in the example
        <img src="JtCARD" class="textCard" alt="card" />
        <img src="JtCARD" class="textCard" alt="card" /> +
        <img src="9tCARD" class="textCard" alt="card" /> 
        <img src="9tCARD" class="textCard" alt="card" />
        `,
    //
    article1_hands_suitability_header: 'The suitability of the hand',
    article1_hands_suitability_text: `
        Once we have identified the type of our starting hand, we need to look at which Suit 
        category this hand belongs to.There are four of these categories.
        <span class="keyword-blue">Single Suited</span>, 
        <span class="keyword-red">Double Suited</span>, 
        Rainbow and Mono.
        <br><br>
        <span class="keyword-blue">Single Suited</span> - from two to three cards of the same suit
        <br><br>
        <span class="keyword-red">Double Suited</span> - Two cards of the same suit + Two cards of a different suit
        <br><br>
        Rainbow - All cards of different suits
        <br><br>
        Mono - All cards of the same suit
        <br><br>
        Let's understand in more detail.
        <br><br>

        Take the starting Unpaired hand for example. 
        <img src="AtCARD" class="textCard" alt="card" />
        <img src="KtCARD" class="textCard" alt="card" />
        <img src="QtCARD" class="textCard" alt="card" /> 
        <img src="2tCARD" class="textCard" alt="card" />
        It can contain from two to four identical suits.
        If the hand has two to three cards of the same suit, it is a <span class="keyword-blue">Single Suited</span> hand:
        `,
    article1_hands_suitability_text1: `
        If your hand has two cards of the same suit + two more other cards of the same suit its a <span class="keyword-red">Double Suited</span> hand:
        `,
    article1_hands_suitability_text2: `
        If all cards of a different suit are in hand, it is a Rainbow hand:
        `,
    article1_hands_suitability_text3: `
        If you have all the cards of the same suit in your hand it is a Mono hand:
        `,
    article1_hands_suitability_text4: `
        Now let's move on to Paired Hands. Hands that have at least one pair. There are only three possible options.
        <span class="keyword-blue">Single Suited</span><span class="keyword-red">Double Suited</span> and Rainbow.
        Let's take the starting hand as an example.
        <img src="9tCARD" class="textCard" alt="card" />
        <img src="9tCARD" class="textCard" alt="card" />
        <img src="AtCARD" class="textCard" alt="card" /> 
        <img src="KtCARD" class="textCard" alt="card" />.
        `,
    article1_hands_suitability_text5: `
        <span class="keyword-blue">Single Suited</span> — from two to three cards of the same suit:
        `,
    article1_hands_suitability_text6: `
        <span class="keyword-red">Double Suited</span> — Two cards of the same suit + Two cards of a different suit:
        `,
    article1_hands_suitability_text7: `
        Rainbow — All cards of different suits:
        `,
    article1_hands_suitability_text8: `
        A mono hand is not possible as two nines cannot be of the same suit.
        Let's take a Double Paired hand as an example.  
        <img src="JtCARD" class="textCard" alt="card" />
        <img src="JtCARD" class="textCard" alt="card" />
        <img src="9tCARD" class="textCard" alt="card" /> 
        <img src="9tCARD" class="textCard" alt="card" />
        `,
    article1_hands_suitability_text9: `
        <span class="keyword-blue">Single Suited</span> - two cards of the same suit (three is impossible)
        `,
    article1_hands_suitability_text10: `
        <span class="keyword-red">Double suited</span> - Two cards of the same suit + Two cards of a different suit
        `,
    article1_hands_suitability_text11: `
        Rainbow - All cards of different suits
        `,
    article1_hands_suitability_conslusion: `
        Mono hand is impossible.
        `,
    article1_hands_strength_header: `
            The strength of the hands
        `,
    article1_hands_strength_text: `
            In conclusion, it is also important to mention the strength of the starting hands depending on 
            their suit of belonging. There are subcategories in double and 
            <span class="keyword-blue">Single Suited</span>, but that's a
            topic for the next article.
        `,
    article1_hands_strength_text1: `
            1&nbsp;&nbsp;&nbsp;<span class="keyword-red">Double Suited</span>
        `,
    article1_hands_strength_text2: `
            2&nbsp;&nbsp;&nbsp;<span class="keyword-blue">Single Suited</span> 
        `,
    article1_hands_strength_text3: `
            3&nbsp;&nbsp;&nbsp;<span class="keyword-bold">Mono</span> 
        `,
    article1_hands_strength_text4: `
            4&nbsp;&nbsp;&nbsp;Rainbow
        `,
    two_side_cards: '+ two Side Cards ',
    //
    moreDetails: 'More details',
  },
  ru: {
    preview_title1: 'Типы рук',
    article_examples: 'Примеры: ',
    article1_title: `
            Типы рук 
            `,
    article1_header: 'Типы стартовых рук',
    article1_introduction: `
            В Pot Limit Omaha существует два типа стартовых рук.
            `,
    //
    article1_unpaired_title: `
            <span>- Unpaired ( стартовая рука в которой нет пары ),</span>
        `,
    article1_unpaired_text: `
            Заметьте, что все они расставлены от старшего номинала карты к младшей. 
            В дальнейшем нам это пригодится. По аналогии с холдемом для упрощенного понимания 
            можно сказать что у нас
            <img src="AtCARD" class="textCard" alt="card" /> - high
            <img src="QtCARD" class="textCard" alt="card" /> - high 
            <img src="9tCARD" class="textCard" alt="card" /> - high
            <img src="JtCARD" class="textCard" alt="card" /> - high                 
            <img src="KtCARD" class="textCard" alt="card" /> - high на префлопе.  
            Но распределяются по принципу "Две High Cards" + " Две Side Cards "
        `,
    article1_paired_title: `
            - Paired ( стартовая рука в которой есть хотя бы одна пара )
            Примеры:
        `,
    //
    article1_paired_text: `
        В данном случае на первое место выходит  старшая комбинация в руке - пара. 
        И к ней по аналогии с примерами из Unpaired добавляются две Side Cards. Так же от старшей к младшей.
        `,
    article1_paired_conclusion: `
        Если в стартовой руке есть две пары, то сначала берется так же старшая пара как основа. Как в примере
        <span>
        <img src="JtCARD" class="textCard" alt="card" />
        <img src="JtCARD" class="textCard" alt="card" /> +
        <img src="9tCARD" class="textCard" alt="card" /> 
        <img src="9tCARD" class="textCard" alt="card" /></span>
        `,
    //
    article1_hands_suitability_header: 'Сьютовость руки',
    article1_hands_suitability_text: `
        Когда мы определили тип нашей стартовой руки, нам нужно посмотреть к какой Suit категории относится эта рука. 
        Всего этих категорий четыре. 
        <span class="keyword-blue">Single Suited</span>, 
        <span class="keyword-red">Double Suited</span>, Rainbow и Mono.
        
        <br><br>
        <span class="keyword-blue">Single Suited</span> - от двух до трех карт одной масти
        <br><br>
        <span class="keyword-red">Double Suited</span> - Две карты одной масти + Две карты другой масти
        <br><br>
        Rainbow - Все карты разных мастей
        <br><br>
        Mono - Все карты одинаковой масти
        <br><br>
        Давайте разбираться подробнее.
        <br><br>

        Возьмем для примера стартовую Unpaired руку 
        <img src="AtCARD" class="textCard" alt="card" />
        <img src="KtCARD" class="textCard" alt="card" />
        <img src="QtCARD" class="textCard" alt="card" /> 
        <img src="2tCARD" class="textCard" alt="card" />
        В ней могут присутствовать от двух до четырех одинаковых мастей.<br />
        Если в руке от двух до трех карт одинаковой масти это <span class="keyword-red"><span class="keyword-blue">Single Suited</span></span> рука:
        `,
    article1_hands_suitability_text1: `
            Если в руке две карты одной масти + еще две другой это <span class="keyword-red">Double Suited</span> рука:
        `,
    article1_hands_suitability_text2: `
        Если в руке все карты разной масти это Rainbow рука:
        `,
    article1_hands_suitability_text3: `
            Если в руке все карты одной масти это Mono рука:
        `,
    article1_hands_suitability_text4: `
        Теперь перейдем к Paired Hands. Руки в которых есть хотя бы одна пара. Тут возможно 
        всего три варианта. <span class="keyword-blue">Single Suited</span>  <span class="keyword-red">Double Suited</span> и Rainbow.
        Для примера возьмем стартовую руку
        <img src="9tCARD" class="textCard" alt="card" />
        <img src="9tCARD" class="textCard" alt="card" />
        <img src="AtCARD" class="textCard" alt="card" /> 
        <img src="KtCARD" class="textCard" alt="card" />
        `,
    article1_hands_suitability_text5: `
        <span class="keyword-blue">Single Suited</span> — от двух до трех карт одной масти:
        `,
    article1_hands_suitability_text6: `
        <span class="keyword-red">Double Suited</span> — Две карты одной масти + Две карты другой масти:
        `,
    article1_hands_suitability_text7: `
        Rainbow — Все карты разных мастей:
        `,
    article1_hands_suitability_text8: `
        Mono рука невозможна, так как две девятки не могут быть одной масти.<br />
        Так же возьмем для примера Double Paired руку  
        <img src="JtCARD" class="textCard" alt="card" />
        <img src="JtCARD" class="textCard" alt="card" />
        <img src="9tCARD" class="textCard" alt="card" /> 
        <img src="9tCARD" class="textCard" alt="card" />
        `,
    article1_hands_suitability_text9: `
        <span class="keyword-blue">Single Suited</span> - две карты одной масти ( три невозможно )
        `,
    article1_hands_suitability_text10: `
        <span class="keyword-red">Double suited</span> - Две карты одной масти + Две карты другой масти
        `,
    article1_hands_suitability_text11: `
        Rainbow - Все карты разных мастей
        `,
    article1_hands_suitability_conslusion: `
        Mono рука невозможна.
        `,

    article1_hands_strength_header: `
            Сила сьют рук
        `,
    article1_hands_strength_text: `
            В заключении еще важно упомянуть про силу стартовых рук в зависимости 
            от их suit принадлежности. В double и <span class="keyword-blue">Single Suited</span> есть подкатегории, но это уже тема для следующей статьи.
        `,
    article1_hands_strength_text1: `
            1&nbsp;&nbsp;&nbsp;<span class="keyword-red">Double Suited</span>
        `,
    article1_hands_strength_text2: `
            2&nbsp;&nbsp;&nbsp;<span class="keyword-blue">Single Suited</span> 
        `,
    article1_hands_strength_text3: `
            3&nbsp;&nbsp;&nbsp;Mono
        `,
    article1_hands_strength_text4: `
            4&nbsp;&nbsp;&nbsp;Rainbow
        `,

    two_side_cards: '+ две side cards ',
    moreDetails: 'Подробнее',
  },
};
